
import React from 'react';
import pageHeaderBg from '../assets/images/page-header-bg.jpg';

function Services() {
  return (
    <div className="services-page">
      {/* Page Header Section */}
      <section className="page-header parallaxie" style={{backgroundImage: `url(${pageHeaderBg})`}}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">Truck Booking & Transportation Services in Coimbatore</h1>
                <nav className="wow fadeInUp">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="/">home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">services</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Services Section Start */}
      <div className="page-services">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              {/* Service Item Start */}
              <div className="service-item wow fadeInUp">
                <div className="icon-box">
                  <img src="/hellotruck-web-images/icon-service-item-1.svg" alt="" />
                </div>                                    
                <div className="service-content">
                  <h3><a href="#">Residential Moving</a></h3>
                  <p>Hassle-free home relocation services tailored to your needs. to your needs.</p>                            
                </div>
                <div className="service-btn">
                  <a href="#" className="readmore-btn">read more</a>  
                </div>
              </div>
              {/* Service Item End */}
            </div>

            <div className="col-lg-3">
              {/* Service Item Start */}
              <div className="service-item wow fadeInUp" data-wow-delay="0.2s">
                <div className="icon-box">
                  <img src="/hellotruck-web-images/icon-service-item-2.svg" alt="" />
                </div>                                    
                <div className="service-content">
                  <h3><a href="#">Commercial Moving</a></h3>
                  <p>Professional moving services tailored to business, ensuring efficient, timely relocations.</p>                            
                </div>
                <div className="service-btn">
                  <a href="#" className="readmore-btn">read more</a>  
                </div>
              </div>
              {/* Service Item End */}
            </div>

            <div className="col-lg-3">
              {/* Service Item Start */}
              <div className="service-item wow fadeInUp" data-wow-delay="0.4s">
                <div className="icon-box">
                  <img src="/hellotruck-web-images/icon-service-item-3.svg" alt="" />
                </div>                                    
                <div className="service-content">
                  <h3><a href="#">Specialty Item Moving</a></h3>
                  <p>Expert handling for fragile and valuable items, ensuring safe transport of antiques.</p>                            
                </div>
                <div className="service-btn">
                  <a href="#" className="readmore-btn">read more</a>  
                </div>
              </div>
              {/* Service Item End */}
            </div>

            <div className="col-lg-3">
              {/* Service Item Start */}
              <div className="service-item wow fadeInUp" data-wow-delay="0.6s">
                <div className="icon-box">
                  <img src="/hellotruck-web-images/icon-service-item-4.svg" alt="" />
                </div>                                    
                <div className="service-content">
                  <h3><a href="#">Eco-Friendly Moving</a></h3>
                  <p>Sustainable moving solutions using eco-friendly materials and practices to reduce.</p>                            
                </div>
                <div className="service-btn">
                  <a href="#" className="readmore-btn">read more</a>  
                </div>
              </div>
              {/* Service Item End */}
            </div>
            
            <div className="col-lg-3">
              {/* Service Item Start */}
              <div className="service-item wow fadeInUp" data-wow-delay="0.8s">
                <div className="icon-box">
                  <img src="/hellotruck-web-images/icon-service-item-5.svg" alt="" />
                </div>                                    
                <div className="service-content">
                  <h3><a href="#">Office Relocation</a></h3>
                  <p>Hassle-free home relocation services tailored to your needs. to your needs.</p>                            
                </div>
                <div className="service-btn">
                  <a href="#" className="readmore-btn">read more</a>  
                </div>
              </div>
              {/* Service Item End */}
            </div>

            <div className="col-lg-3">
              {/* Service Item Start */}
              <div className="service-item wow fadeInUp" data-wow-delay="1s">
                <div className="icon-box">
                  <img src="/hellotruck-web-images/icon-service-item-6.svg" alt="" />
                </div>                                    
                <div className="service-content">
                  <h3><a href="#">Packing & Unpacking</a></h3>
                  <p>Professional moving services tailored to business, ensuring efficient, timely relocations.</p>                            
                </div>
                <div className="service-btn">
                  <a href="#" className="readmore-btn">read more</a>  
                </div>
              </div>
              {/* Service Item End */}
            </div>

            <div className="col-lg-3">
              {/* Service Item Start */}
              <div className="service-item wow fadeInUp" data-wow-delay="1.2s">
                <div className="icon-box">
                  <img src="/hellotruck-web-images/icon-service-item-7.svg" alt="" />
                </div>                                    
                <div className="service-content">
                  <h3><a href="#">Storage Solutions</a></h3>
                  <p>Expert handling for fragile and valuable items, ensuring safe transport of antiques.</p>                            
                </div>
                <div className="service-btn">
                  <a href="#" className="readmore-btn">read more</a>  
                </div>
              </div>
              {/* Service Item End */}
            </div>

            <div className="col-lg-3">
              {/* Service Item Start */}
              <div className="service-item wow fadeInUp" data-wow-delay="1.6s">
                <div className="icon-box">
                  <img src="/hellotruck-web-images/icon-service-item-8.svg" alt="" />
                </div>                                    
                <div className="service-content">
                  <h3><a href="#">Moving Assistance</a></h3>
                  <p>Sustainable moving solutions using eco-friendly materials and practices to reduce.</p>                            
                </div>
                <div className="service-btn">
                  <a href="#" className="readmore-btn">read more</a>  
                </div>
              </div>
              {/* Service Item End */}
            </div>
          </div>
        </div>
      </div>
      {/* Our Services Section End */}

      {/* Why Choose Us Section Start */}
      <div className="why-choose-us dark-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="why-choose-box">
                {/* Why Choose Content Start */}
                <div className="why-choose-content">
                  {/* Section Title Start */}
                  <div className="section-title">
                    <h3 className="wow fadeInUp">why choose us</h3>
                    <h2 className="text-anime-style-2" data-cursor="-opaque">Why we're the preferred choice <span>for moving</span></h2>
                  </div>
                  {/* Section Title End */}

                  {/* Why Choose Body Start */}
                  <div className="why-choose-body wow fadeInUp" data-wow-delay="0.2s">
                    <ul>
                      <li>Timely service with no hidden fees.</li>
                      <li>Safe, secure transport for your belongings.</li>
                      <li>Customized moving plans to fit your needs.</li>
                      <li>Eco-friendly practices for a sustainable move.</li>
                    </ul>
                  </div>
                  {/* Why Choose Body End */}
                </div>
                {/* Why Choose Content End */}

                {/* Request Quote Form Start */}
                <div className="request-quote-form-box wow fadeInUp" data-wow-delay="0.4s">
                  <h3>request a quote</h3>

                  {/* Request Quote Form Start */}
                  <div className="request-quote-form">
                    <form id="requestquoteForm" action="#" method="POST">
                      <div className="row">
                        <div className="form-group col-md-6 mb-4">
                          <input type="text" name="name" className="form-control" id="name" placeholder="name" required />
                          <div className="help-block with-errors"></div>
                        </div>
                
                        <div className="form-group col-md-6 mb-4">
                          <input type="email" name="email" className="form-control" id="email" placeholder="Email" required />
                          <div className="help-block with-errors"></div>
                        </div>
                
                        <div className="form-group col-md-6 mb-4">
                          <input type="text" name="phone" className="form-control" id="phone" placeholder="Phone" required />
                          <div className="help-block with-errors"></div>
                        </div>
            
                        <div className="form-group col-md-6 mb-4">
                          <input type="date" name="date" className="form-control" id="date" required />
                          <div className="help-block with-errors"></div>
                        </div>

                        <div className="form-group col-md-6 mb-4">
                          <input type="text" name="distance" className="form-control" id="distance" placeholder="distance" required />
                          <div className="help-block with-errors"></div>
                        </div>

                        <div className="form-group col-md-6 mb-4">
                          <select name="movetype" className="form-control form-select" id="movetype" required>
                            <option value="" disabled selected>move type</option>
                            <option value="residential">Residential Moving</option>
                            <option value="commercial">Commercial Moving</option>
                            <option value="office">Office Relocation</option>
                          </select>
                          <div className="help-block with-errors"></div>
                        </div>

                        <div className="form-group col-md-12 mb-4">
                          <select name="services" className="form-control form-select" id="services" required>
                            <option value="" disabled selected>service type</option>
                            <option value="residential_moving">Residential Moving</option>
                            <option value="commercial_moving">Commercial Moving</option>
                            <option value="specialty_item">Specialty Item Moving</option>
                            <option value="eco_friendly">Eco-Friendly Moving</option>
                            <option value="office_relocation">Office Relocation</option>
                            <option value="packing_unpacking">Packing & Unpacking</option>
                            <option value="storage_solutions">Storage Solutions</option>
                            <option value="moving_assistance">Moving Assistance</option>
                          </select>
                          <div className="help-block with-errors"></div>
                        </div>

                        <div className="form-group col-md-12">
                          <button type="submit" className="btn-default">contact us now</button>
                          <div id="msgSubmit" className="h3 hidden"></div>
                        </div>
                      </div>
                    </form>
                  </div>
                  {/* Request Quote Form End */}
                </div>
                {/* Request Quote Form End */}
              </div>
            </div>  
          </div>
        </div>
      </div>
      {/* Why Choose Us Section End */}
      
      {/* Our Testimonials Section Start */}
      <div className="our-testimonials">
        <div className="container">
          <div className="row section-row">
            <div className="col-lg-12">
              {/* Section Title Start */}
              <div className="section-title section-title-center">
                <h3 className="wow fadeInUp">testimonials</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">Words of appreciation from <span>our customers</span></h2>
              </div>
              {/* Section Title End */}
            </div>   
          </div>

          <div className="row">
            <div className="col-lg-12">
              {/* Testimonial Slider Start */}
              <div className="testimonial-slider">
                <div className="swiper">
                  <div className="swiper-wrapper" data-cursor-text="Drag">
                    {/* Testimonial Slide Start */}
                    <div className="swiper-slide">
                      <div className="testimonial-item">        
                        <div className="author-image">
                          <figure className="image-anime">
                            <img src="/hellotruck-web-images/author-1.jpg" alt="" />
                          </figure>
                        </div>
                    
                        <div className="author-content">
                          <div className="author-title">
                            <h3>Suresh, Thudiyalur</h3>
                          </div>
                          <div className="author-rating">
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                          </div>
                        </div>

                        <div className="testimonial-content">
                          <p>Hello Truck helped us with our office relocation last month. The service was prompt and efficient. The team was careful with our equipment and furniture. The only minor issue was a slight delay in arrival time, but they made up for it with fast service.</p>
                        </div>
                      </div>
                    </div>
                    {/* Testimonial Slide End */}

                    {/* Testimonial Slide Start */}
                    <div className="swiper-slide">
                      <div className="testimonial-item">        
                        <div className="author-image">
                          <figure className="image-anime">
                            <img src="/hellotruck-web-images/author-2.jpg" alt="" />
                          </figure>
                        </div>
                    
                        <div className="author-content">
                          <div className="author-title">
                            <h3>Kannan, Peelamedu</h3>
                          </div>
                          <div className="author-rating">
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                          </div>
                        </div>

                        <div className="testimonial-content">
                          <p>As a business owner, reliable transportation is crucial for my operations. Hello Truck has been our logistics partner for over 2 years now. Their consistent service, transparent pricing, and responsive customer support make them stand out from other providers in Coimbatore.</p>
                        </div>
                      </div>
                    </div>
                    {/* Testimonial Slide End */}

                    {/* Testimonial Slide Start */}
                    <div className="swiper-slide">
                      <div className="testimonial-item">        
                        <div className="author-image">
                          <figure className="image-anime">
                            <img src="/hellotruck-web-images/author-1.jpg" alt="" />
                          </figure>
                        </div>
                    
                        <div className="author-content">
                          <div className="author-title">
                            <h3>Ganesan, Singanallur</h3>
                          </div>
                          <div className="author-rating">
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                          </div>
                        </div>

                        <div className="testimonial-content">
                          <p>I recently used Hello Truck for my house shifting from Coimbatore to Tiruppur, and I couldn't be happier! The team was professional, and they handled all my belongings with care. Highly recommend their services!</p>
                        </div>
                      </div>
                    </div>
                    {/* Testimonial Slide End */}
                  </div>
                  <div className="testimonial-btn">
                    <div className="testimonial-btn-prev"></div>
                    <div className="testimonial-btn-next"></div>
                  </div>
                </div>
              </div>
              {/* Testimonial Slider End */}
            </div>
          </div>
        </div>
      </div>
      {/* Our Testimonials Section End */}

      {/* Our Faqs Section Start */}
      <div className="our-faqs">
        <div className="container-fluid">
          <div className="row no-gutters">
            <div className="col-lg-6">
              <div className="faq-content-box">
                {/* Our Faqs Content Start */}
                <div className="our-faqs-content">
                  {/* Section Title Start */}
                  <div className="section-title section-title-center">
                    <h3 className="wow fadeInUp">frequently asked questions</h3>
                    <h2 className="text-anime-style-2" data-cursor="-opaque">Answers to your <span>moving questions</span></h2>
                  </div>
                  {/* Section Title End */}

                  {/* FAQ Accordion Start */}
                  <div className="faq-accordion" id="faqaccordion">
                    {/* FAQ Item Start */}
                    <div className="accordion-item wow fadeInUp">
                      <h2 className="accordion-header" id="heading1">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1" aria-expanded="true" aria-controls="collapse1">
                          How far in advance should I book my move?
                        </button>
                      </h2>
                      <div id="collapse1" className="accordion-collapse collapse show" aria-labelledby="heading1" data-bs-parent="#faqaccordion">
                        <div className="accordion-body">
                          <p>We recommend booking your move at least 2-4 weeks in advance to ensure availability, especially during peak seasons.</p>
                        </div>
                      </div>
                    </div>
                    {/* FAQ Item End */}

                    {/* FAQ Item Start */}
                    <div className="accordion-item wow fadeInUp" data-wow-delay="0.2s">
                      <h2 className="accordion-header" id="heading2">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                          Do you provide packing materials?
                        </button>
                      </h2>
                      <div id="collapse2" className="accordion-collapse collapse" aria-labelledby="heading2" data-bs-parent="#faqaccordion">
                        <div className="accordion-body">
                          <p>We recommend booking your move at least 2-4 weeks in advance to ensure availability, especially during peak seasons.</p>
                        </div>
                      </div>
                    </div>
                    {/* FAQ Item End */}

                    {/* FAQ Item Start */}
                    <div className="accordion-item wow fadeInUp" data-wow-delay="0.4s">
                      <h2 className="accordion-header" id="heading3">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                          Are my belongings insured during the move?
                        </button>
                      </h2>
                      <div id="collapse3" className="accordion-collapse collapse" aria-labelledby="heading3" data-bs-parent="#faqaccordion">
                        <div className="accordion-body">
                          <p>We recommend booking your move at least 2-4 weeks in advance to ensure availability, especially during peak seasons.</p>
                        </div>
                      </div>
                    </div>
                    {/* FAQ Item End */}

                    {/* FAQ Item Start */}
                    <div className="accordion-item wow fadeInUp" data-wow-delay="0.6s">
                      <h2 className="accordion-header" id="heading4">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                          Do you offer long-distance moving services?
                        </button>
                      </h2>
                      <div id="collapse4" className="accordion-collapse collapse" aria-labelledby="heading4" data-bs-parent="#faqaccordion">
                        <div className="accordion-body">
                          <p>We recommend booking your move at least 2-4 weeks in advance to ensure availability, especially during peak seasons.</p>
                        </div>
                      </div>
                    </div>
                    {/* FAQ Item End */}
                  </div>
                  {/* FAQ Accordion End */}
                </div>
                {/* Our Faqs Content End */}
              </div>
            </div>

            <div className="col-lg-6">
              {/* Faqs Image Start */}
              <div className="faqs-image">
                <div className="faq-image">
                  <figure className="image-anime">
                    <img src="/hellotruck-web-images/faq-image.jpg" alt="" />
                  </figure>
                </div>

                {/* Intro Video Button Start */}
                <div className="intro-video-button">
                  <a href="/hellotruck-web-images/hello_truck_video.mp4" className="popup-video" data-cursor-text="Play">
                    <figure>
                      <img src="/hellotruck-web-images/intro-video-circle.svg" alt="" />
                    </figure>

                    <div className="into-video-play-icon">
                      <img src="/hellotruck-web-images/intro-video-play-btn.svg" alt="" />
                    </div>
                  </a>
                </div>
                {/* Intro Video Button End */}
              </div>
              {/* Faqs Image End */}
            </div>
          </div>
        </div>
      </div>
      {/* Our Faqs Section End */}
    </div>
  );
}

export default Services;
